import { Button, Form, Input, Select } from "antd";
import axios from "axios";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
const { Option } = Select;

const AddAdmin = (
  { adminDetails, onCloseMethod }: { adminDetails: any; onCloseMethod: any },
  props: any
): ReactElement => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState(undefined);
  const [adminGroup, setAdminGroup] = useState([]);
  const [error, setError] = useState("");
  const [type, setType] = useState<any>();
  const [userGroup, setUserGroup] = useState([]);

  const [groupOptions, setGroupOptions] = useState({
    loading: false,
    list: [],
  });

  // ******************************
  const fetchCorporateDetails = async () => {
    if (adminDetails?.email) {
      await fetch(
        `${process.env.REACT_APP_AUTH_API}/admin/details?email=${adminDetails?.email}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            form.resetFields();
            setAdminData(res?.admin);
            setAdminGroup(res?.groups?.map((group) => group?.groupId));
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  // ******************************

  const getGroupOptions = useCallback(
    async (key?: string) => {
      setGroupOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
      return axios
        .get(
          `${encodedUri}/group/all` +
            (type ? `&type=${type}` : ``) +
            (key ? `&name=${key}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setGroupOptions({
            loading: false,
            list: res.data?.groups?.map((group) => ({
              label: group.name,
              value: group.id,
            })),
          });
        })
        .catch((err) => {
          setGroupOptions({ loading: false, list: [] });
          console.error("Groups: Error", err);
        });
    },
    [type]
  );

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      name: data.name,
      email: data.email,
      password: data.password,
      groupActives: userGroup.map((item) => ({
        groupId: item,
        isActive: true,
      })),
    };

    console.log("Group:", userGroup);

    if (adminData) {
      await fetch(`${process.env.REACT_APP_AUTH_API}/admin`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          email: adminData?.email,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Admin Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_AUTH_API}/admin/register`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Admin Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  // ****************************************
  // const handleSearch = React.useMemo(() => {
  //   const loadOptions = (value: string, field: string) => {
  //     fetchRef.current += 1;
  //     const fetchId = fetchRef.current;

  //     if (fetchId !== fetchRef.current) {
  //       return;
  //     }
  //     if (value) {
  //       if (field === "group") getGroupOptions(value);
  //     }
  //   };

  //   return debounce(loadOptions, 800);
  // }, [getGroupOptions]);
  // ****************************************

  useEffect(() => {
    getGroupOptions();
  }, [getGroupOptions]);

  useEffect(() => {
    if (adminData || adminGroup) {
      form.resetFields();
      // setLogoUrl(visibleData?.logo);
    }
  }, [adminData, adminGroup, adminDetails]);

  useEffect(() => {
    if (adminDetails) {
      setAdminData(adminDetails);
    }
  }, [adminDetails]);

  useEffect(() => {
    if (adminDetails) fetchCorporateDetails();
  }, [adminDetails]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      {console.log("data:", adminGroup)}
      <Form
        name="control-hooks"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        className="ant-form ant-form-vertical"
        onFinish={onSubmit}
        form={form} // like ref
        layout="vertical"
        // requiredMark="optional"
        autoComplete="off"
        initialValues={{
          ...adminData,
          name: adminData?.fullName,
          groupId: adminGroup,
        }}
      >
        <Form.Item
          hasFeedback
          label="User Name"
          rules={[
            {
              required: true,
              message: "Name is Required!",
            },
          ]}
          name="name"
          initialValue={adminData?.fullName}
        >
          <Input id="name" type="text" placeholder="Enter Name" />
        </Form.Item>

        {!adminData && (
          <>
            <Form.Item
              hasFeedback
              label="Email"
              rules={[
                {
                  required: true,
                  message: "Email is required!",
                },
                {
                  validator: async (_, email) => {
                    if (
                      email &&
                      !String(email)
                        .toLowerCase()
                        ?.match(
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        )
                    ) {
                      return Promise.reject(new Error("Enter valid email"));
                    }
                  },
                },
              ]}
              name="email"
            >
              <Input id="email" type="email" placeholder="Enter Email" />
            </Form.Item>

            <Form.Item
              hasFeedback
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Password is Required!",
                },
              ]}
              name="password"
            >
              <Input
                id="password"
                type="password"
                placeholder="Enter Password"
              />
            </Form.Item>
          </>
        )}
        <Form.Item
          hasFeedback
          label={`Groups`}
          name="groupId"
          initialValue={adminGroup}
        >
          <Select
            defaultValue={adminGroup}
            allowClear
            showSearch
            placeholder="Select Group"
            optionFilterProp="children"
            onChange={(val) => {
              setUserGroup(val);
            }}
            filterOption={(input, option) =>
              option.children
                .toString()
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            mode="multiple"
          >
            {groupOptions?.list?.map((group, i) => (
              <Option value={group?.value} key={i}>
                {group?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* <Form.Item
            hasFeedback
            label="Photo"
            rules={[
              {
                required: true,
                message: "Admin Image is required!",
              },
              {
                validator: async (_, value) => {
                  if (value && !validUrl(value)) {
                    return Promise.reject(new Error("Enter valid url"));
                  }
                },
              },
            ]}
            name="adminImage"
          >
            <Input
              id="adminImage"
              type="text"
              placeholder="Enter Admin Url"
              onChange={(e) => {
                setAdminUrl(e.target.value);
              }}
            />
          </Form.Item>

          {adminUrl && (
            <div className="mt-2" style={{ minWidth: "100%" }}>
              <Image
                src={adminUrl}
                height={150}
                className="img img-thumbnail"
                onLoad={(e) => {
                  const width = (e.target as any).naturalWidth;
                  const height = (e.target as any).naturalHeight;
                  const ratio = width / height;

                  if (ratio.toFixed(1) === "2.5" && height > 400) {
                    setError("");
                  } else {
                    setError(
                      "Image Ratio must be around 2.3 & minimum Height is 400"
                    );
                  }
                }}
              />
              <p className="red-txt mt-1">{error}</p>
            </div>
          )} */}
        <div className="buttons-container">
          <Button
            disabled={loading || !!error}
            loading={(loading ? "loading" : undefined) as any}
            type="primary"
            htmlType="submit"
            className="add-submit-btn text-center mr-2"
          >
            Submit
          </Button>
          <Button
            type="ghost"
            htmlType="button"
            onClick={() => {
              form?.resetFields();
              // setAdminUrl(undefined);
            }}
            className="reset-submit-btn text-center mr-2"
          >
            Reset
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddAdmin;
